module.exports = __webpack_public_path__ + "img/art-ron-2.3cf1b075.jpg";